module.exports = __webpack_public_path__ + "c8f95562f9c16e8f959fc04599d1acc2.png";